











































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
  Inject
} from "@/shared/vuepack";
import moment from "moment";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import { formatCurrency } from "@/shared/currency";
import { useThemeStore } from "@/shared/store/theme";
import { useEmployerPayrollStore } from "@/employer/store/employerPayroll";

@Component({
  components: {
    Button,
    Checkbox
  }
})
export default class EmployeePayrollRowEdit extends Vue {

  themeStore = useThemeStore();
  employerPayrollStore = useEmployerPayrollStore();

  @Inject()
  $validator: Validator;

  @Prop() contribution: any; // EmployeeContribution;

  @Prop() isLocked: boolean;


  formatCurrency = formatCurrency;

  isEmployeeCurrentAndFutureUpdate = false;
  originalEmployeeAmount = null;
  editedEmployeeAmount = null;
  editedEmployerAmount = null;
  editedLiftAmount = null;
  showConfirmModal = false;
  acceptedWarning = false;

  beforeMount () {
    const { contributionLimit } = this.contribution;

    this.$validator.extend(`liftInputMaximum${this.contribution.employeeId}`, {
      getMessage: inputValue => {
        const max = contributionLimit - (this.employeeAmountInput + this.employerAmountInput);

        if (max < 0) {
          return "Please lower the other inputs to have a higher value for the lift amount";
        }

        return `Lift contribution value must be less than ${this.formatCurrency(max)}`;
      },
      validate: inputValue => {
        return (this.employerAmountInput + this.employeeAmountInput + inputValue) <= contributionLimit;
      }
    });
    this.$validator.extend(`employeeInputMaximum${this.contribution.employeeId}`, {
      getMessage: inputValue => {
        const max =  contributionLimit - (this.employerAmountInput + this.liftAmountInput);

        if (max < 0) {
          return "Please lower the other inputs to have a higher value for the employee amount";
        }

        return `Employee contribution value must be less than ${this.formatCurrency(max)}`;
      },
      validate: inputValue => {
        return (this.employerAmountInput + this.liftAmountInput + inputValue) <= contributionLimit;
      }
    });
    this.$validator.extend(`employerInputMaximum${this.contribution.employeeId}`, {
      getMessage: inputValue => {
        const max =  contributionLimit - (this.employeeAmountInput + this.liftAmountInput);

        if (max < 0) {
          return "Please lower the other inputs to have a higher value for the employer amount";
        }

        return `Employer contribution value must be less than ${this.formatCurrency(max)}`;
      },
      validate: inputValue => {
        return (this.employeeAmountInput + this.liftAmountInput + inputValue) <= contributionLimit;
      }
    });
  }

  mounted () {
    this.isEmployeeCurrentAndFutureUpdate = false;
    this.originalEmployeeAmount = this.contribution.employeeAmount;
    this.editedEmployeeAmount = this.contribution.employeeAmount;
    this.editedEmployerAmount = this.contribution.employerAmount;
    this.editedLiftAmount = this.contribution.liftAmount;
    this.showConfirmModal = false;
  }

  disableEditing () {
    this.employerPayrollStore.setSelectedEmployeeId(null);
  }

  saveClicked () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      if (this.warningShown && !this.acceptedWarning) {
        return;
      }

      if (this.contribution.hasChange) {
        this.showConfirmModal = true;
        return;
      }
      this.postUpdate();
    });
  }

  postUpdate () {
    const editedContribution = {
      ...this.contribution,
      employeeAmount: this.employeeAmountInput,
      employerAmount: this.employerAmountInput,
      liftAmount: this.liftAmountInput,
      isEmployeeCurrentFuturePayrollUpdate: this.isEmployeeCurrentAndFutureUpdate
    };

    this.employerPayrollStore.saveEmployeeContribution(editedContribution)
    .then(result => {
      this.employerPayrollStore.setSelectedEmployeeId(null);
    })
    .finally(() => {
      this.hideModalAndStopEdit();
    });
  }

  confirmChangeModal () {
    this.postUpdate();
  }

  hideModalAndStopEdit () {
    this.showConfirmModal = false;
    this.employerPayrollStore.setSelectedEmployeeId(null);
  }

  @Watch("liftAmountInput")
  @Watch("employerAmountInput")
  @Watch("employeeAmountInput")
  validateInputs () {
    this.$nextTick(() => {
      this.$validator.validateAll();
    });
  }

  get isEmployeeAmountChanged () {
    return this.originalEmployeeAmount !== this.editedEmployeeAmount;
  }

  get warningShown () {
    return !this.$validator.errors.any() && (this.employerAmountPlusWarning || this.employerAmountMinusWarning);
  }

  get employerAmountPlusWarning () {
    const employerAmountDifference = this.employerAmountInput - this.contribution.totalEmployerAmountRemaining;

    if (employerAmountDifference > 0) {
      return `The new amount will result in ${this.contribution.employeeFirstName} ` +
        `receiving ${formatCurrency(employerAmountDifference)} more than the annual Employer contribution.`;
    }

    return null;
  }

  get employerAmountMinusWarning () {
    const employerAmountDifference = this.contribution.totalEmployerAmountRemaining - this.employerAmountInput;

    if (employerAmountDifference > 0 && !this.contribution.countRemainingPayrollDates) {
      return `The new amount will result in ${this.contribution.employeeFirstName} ` +
        `receiving ${formatCurrency(Math.abs(employerAmountDifference))} less than the annual Employer contribution.`;
    }

    return null;
  }

  get submitDisabled () {
    return this.warningShown && !this.acceptedWarning;
  }

  get employeeAmountInput () {
    return this.editedEmployeeAmount;
  }

  set employeeAmountInput (amount) {
    this.editedEmployeeAmount = amount;
  }

  get employerAmountInput () {
    return this.editedEmployerAmount;
  }

  set employerAmountInput (amount) {
    this.editedEmployerAmount = amount;
  }

  get liftAmountInput () {
    return this.editedLiftAmount;
  }

  set liftAmountInput (amount) {
    this.editedLiftAmount = amount;
  }

  get formatedLastModified () {
    return moment(this.contribution.lastModified).format("MMM DD, YYYY");
  }

  onClose (e) {
    this.hideModalAndStopEdit();
  }
}
